const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const MAX_INPUT_LENGTH = 500;
export function isValidEmail(value) {
    return EMAIL_PATTERN.test(value.trim()) && value.trim().length <= 254;
}
/** AU postcodes are 4 digits; NZ are 4 digits too. */
export function isValidPostcode(value) {
    return /^\d{4}$/.test(value.trim());
}
/**
 * Defensive cleanup for free-text user input crossing the API boundary:
 * trims, strips control characters and caps the length.
 */
export function sanitizeInput(value, maxLength = MAX_INPUT_LENGTH) {
    return (value
        .trim()
        // eslint-disable-next-line no-control-regex
        .replace(/[\u0000-\u001f\u007f]/g, '')
        .slice(0, maxLength));
}
export function isNonEmptyString(value) {
    return typeof value === 'string' && value.trim().length > 0;
}
//# sourceMappingURL=validation.js.map